<template>
  <MainLayout>
    <b-row id="userManagement">
      <b-col class="shadow-sm">
        <h4 class="card-title font-weight-bold">
          Benutzerverwaltung
        </h4>

        <b-card-body>
          <b-row v-if="userView">
            <UserEdit />
          </b-row>
          <b-row v-else>
            <UserOverview />
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
    <div style="height: 500px" />
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import UserOverview from "@/components/UserManagement/UserOverview.vue";
import UserEdit from "@/components/UserManagement/UserEdit.vue";

export default {
  components: {
    MainLayout,
    UserOverview,
    UserEdit,
  },
  data() {
    return {
      userView: false,
      userId: null,
    };
  },
  watch: {
    "$route.params.userId"(newValue) {
      this.userId = newValue;

      if (newValue) {
        this.userView = true;
      } else {
        this.userView = false;
      }
    },
  },

  mounted() {
    if (this.$route.params.userId) {
      this.userView = true;
    }
  },

  methods: {
    redirect() {
      this.$router.push({
        path: "users/1",
      });
    },
  },
};
</script>

<style scoped></style>
